import { z } from "zod";

export const MemberObjectSchema = z.object({
  id: z.string(),
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  title: z.string().nullable(),
  hasAdminAccess: z.boolean(),
  hasSuperViewerAccess: z.boolean(),
  hasDepartmentAccess: z.boolean(),
  hasDepartmentPayrollAccess: z.boolean(),
  hasBusinessUnitAccess: z.boolean(),
  hasBusinessUnitPayrollAccess: z.boolean(),
  hasPaymentsAccess: z.boolean(),
  hasFinancialAnalysisAccess: z.boolean(),
  hasApprovalBypassAccess: z.boolean(),
  hasVendorAdminAccess: z.boolean(),
  hasUserAdminAccess: z.boolean(),
  hasSpendRequestAccess: z.boolean(),
  isSigner: z.boolean(),
  approvesRequestsForDepartment: z.boolean(),
  approvesRequestsForBusinessUnit: z.boolean(),
  submitsSpendRequestsForOthers: z.boolean(),
  enabled: z.boolean(),
  receiveEmail: z.boolean(),
  receiveSlack: z.boolean(),
  manager: z
    .object({
      id: z.string(),
      firstName: z.string(),
      lastName: z.string(),
      email: z.string(),
    })
    .nullable(),
  location: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .nullable(),
  departments: z
    .object({
      id: z.string(),
      name: z.string(),
      externallyManaged: z.boolean().optional().nullish(),
    })
    .array(),
  businessUnits: z
    .object({
      id: z.string(),
      name: z.string(),
      externallyManaged: z.boolean().optional().nullish(),
    })
    .array(),
  groups: z
    .object({
      id: z.string(),
      name: z.string(),
    })
    .array(),
  entities: z
    .object({
      id: z.string(),
      name: z.string(),
      externallyManaged: z.boolean().optional().nullish(),
    })
    .array(),
});

export const MemberCreateSchema = z.object({
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  title: z.string().nullable(),
  hasAdminAccess: z.boolean(),
  hasSuperViewerAccess: z.boolean(),
  hasDepartmentAccess: z.boolean(),
  hasDepartmentPayrollAccess: z.boolean(),
  hasBusinessUnitAccess: z.boolean(),
  hasBusinessUnitPayrollAccess: z.boolean(),
  hasPaymentsAccess: z.boolean(),
  hasFinancialAnalysisAccess: z.boolean(),
  hasApprovalBypassAccess: z.boolean(),
  hasVendorAdminAccess: z.boolean(),
  hasUserAdminAccess: z.boolean().optional(),
  hasSpendRequestAccess: z.boolean(),
  isSigner: z.boolean(),
  managerId: z.string().nullable(),
  departmentIds: z.string().array(),
  businessUnitIds: z.string().array(),
  entityIds: z.string().array().optional(),
  locationId: z.string().nullable(),
  groupIds: z.string().array(),
  submitsSpendRequestsForOthers: z.boolean(),
  approvesRequestsForDepartment: z.boolean(),
  approvesRequestsForBusinessUnit: z.boolean(),
  sendNewMemberEmail: z.boolean().optional(),
});

export type MemberObject = z.infer<typeof MemberObjectSchema>;
